import 'react-native-gesture-handler';

import React, { useEffect, useState } from 'react';
import { useFontLoader } from './src/utils/fontLoader';
import { SignedInStatusProvider } from './src/context/SignedInContext';
import RootNavigation from './src/navigators/RootNavigator';
import { COLORS } from './src/constants/colors';
import { StyleSheet } from 'react-native';
import { textStyles } from './src/constants/textStyles';
import { GraphQLProvider } from './src/graphql';
import { QueryContextProvider } from './src/context/QueryContextProvider';
import { MB_deviceInfoInitialize } from '@mightybyte/rnw.utils.device-info';
import { MB_accessTokenUtils } from '@mightybyte/rnw.utils.access-token-utils';
import {
  initialWindowMetrics,
  SafeAreaProvider,
  SafeAreaView,
} from 'react-native-safe-area-context';
import { getNewToken } from './src/graphql/getNewToken';
import { SeenNotificationProvider } from './src/context/NotificationContext';
import {
  MB_PortalHost,
  MB_PortalProvider,
} from './src/components/helperComponents/ToolTip/MB_Portal';

const App = () => {
  useFontLoader();
  const [isInitialSetupComplete, setIsInitialSetupComplete] = useState(false);

  useEffect(() => {
    async function appInitialSetup() {
      MB_accessTokenUtils.setAccessTokenRefreshEndpointFunction(getNewToken);
      await MB_deviceInfoInitialize();
      setIsInitialSetupComplete(true);
    }

    appInitialSetup();
  }, []);

  if (!isInitialSetupComplete) {
    return null;
  }

  return (
    <SafeAreaProvider initialMetrics={initialWindowMetrics}>
      <SafeAreaView style={styles.safeAreaView}>
        <MB_PortalProvider>
          <GraphQLProvider>
            <QueryContextProvider>
              <SignedInStatusProvider>
                <SeenNotificationProvider>
                  <RootNavigation />
                  <MB_PortalHost name="root-portal" />
                </SeenNotificationProvider>
              </SignedInStatusProvider>
            </QueryContextProvider>
          </GraphQLProvider>
        </MB_PortalProvider>
      </SafeAreaView>
    </SafeAreaProvider>
  );
};

export default App;

const styles = StyleSheet.create({
  safeAreaView: {
    flex: 1,
  },
});
